function parseInteger(v) {
  if (!v) return 0;
  const result = parseInt(v, 10);
  if (isNaN(result)) throw new Error("Not parseable as an integer");
  return result;
}

export default parseInteger;
